import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-view-image-modal',
    templateUrl: './view-image-modal.component.html'
})
export class ViewImageModalComponent implements OnInit {

    imageURL = '';

    constructor(public dialogRef: MatDialogRef<ViewImageModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.imageURL = this.data;
    }


    close(): void {
        this.dialogRef.close();
    }
}
